if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}


// ✅ 自定义 Buy Now 逻辑（增强版：自动取数量输入框的值）
document.addEventListener("DOMContentLoaded", () => {
  const customBtn = document.getElementById("CustomBuyNow");
  if (!customBtn) return;

  customBtn.addEventListener("click", () => {
    // 1️⃣ 获取当前变体 ID
    const variantInput = document.querySelector('product-form form [name="id"]');
    const variantId = variantInput ? variantInput.value : null;

    // 2️⃣ 获取数量输入框的值
    const quantityInput =
      document.querySelector('input[name="quantity"]') ||
      document.querySelector('#quantity') ||
      document.querySelector('[data-quantity-input]');
    const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

    // 3️⃣ 构建产品信息
    const productData = {
      id: customBtn.dataset.productId || variantId,
      name: customBtn.dataset.title || "Unnamed Product",
      variant: customBtn.dataset.variant || "Default Variant",
      price: parseFloat(customBtn.dataset.price || "0"),
      quantity, // ✅ 动态获取数量
      image: customBtn.dataset.image
        ? 'https:' + customBtn.dataset.image
        : document.querySelector('.product__media img')?.src || '',
    };

    // 4️⃣ 构建订单数据结构
    const orderData = {
      items: [productData],
      subtotal: productData.price * productData.quantity,
      shippingCost: 0.0,
      tax: 0.0,
      total: +(productData.price * productData.quantity).toFixed(2),
      store_logo: "",
      store_domain: window.location.origin,
      store_currency:window.Shopify.currency.active,
    };
  
    // 5️⃣ Base64 编码
    const orderInfo = btoa(unescape(encodeURIComponent(JSON.stringify(orderData))));

    // 6️⃣ 调试输出
    console.log("🧾 订单数据:", orderData);
    //console.log("🔐 Base64 编码:", orderInfo);

    // 7️⃣ 跳转到自定义结账页（如需启用）
    window.location.href = `https://cart.laurangelers.us?orderInfo=${orderInfo}`;
  });
});

